/* eslint-disable @typescript-eslint/no-explicit-any */
import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import Error from "../../Error/Index";
import { myHeaders } from "../../../config/axios";
import { URL_API } from "../../../config/default";
import { Modal } from "flowbite-react";
import Pagination from "../../../utils/pagination";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "../../../components/UI/table";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "../../../components/UI/dropdown-menu";
import {
  Edit,
  MapPin,
  MoreHorizontal,
  Power,
  Trash2,
} from "lucide-react";
import { Badge } from "../../../components/UI/badge";
import { CustomToast } from "../../../utils/custom-toast";
import { Button } from "../../../components/UI/Button";

const Usuarios = () => {
  const [user, setUser] = useState<any>(null);
  const [modalUser, setModalUser] = useState(false);
  const [select, setSelect] = useState(0);
  const [filter, setFilter] = useState<{
    status?: any;
  }>({
    status: "activo",
  });

  const onClick = (e: any, value: any) => {
    switch (e.target.name) {
      case "status":
        {
          let formdata = new FormData();
          formdata.append("status", value.status);

          const requestOptions = {
            method: "POST",
            body: formdata,
            headers: {
              Authorization: myHeaders, // Un ejemplo de header de autenticación
            },
          };

          fetch(`${URL_API}/users/${value.id}`, requestOptions)
            .then(async () => {
              //const property = await response.json();

              return CustomToast({
                status: 200,
                msg: "",
                title: "Usuario Inactivo",
              });
            })
            .then((result) => console.log(result))
            .catch((error) => console.error(error));
        }
        break;case "editar":
        {
          setModalUser(true);
          setUser(value);
        }
        break;
      default:
        break;
    }
  };

  const getStatusBadge = (status: string) => {
    switch (status.toLowerCase()) {
      case "activo":
        return (
          <Badge className="bg-green-100 text-green-800 hover:bg-green-100">
            Activo
          </Badge>
        );
      case "inactivo":
        return (
          <Badge className="bg-red-100 text-red-800 hover:bg-red-100">
            Inactivo
          </Badge>
        );
      case "pendiente":
        return (
          <Badge className="bg-yellow-100 text-yellow-800 hover:bg-yellow-100">
            Pendiente
          </Badge>
        );
      default:
        return <Badge variant="secondary">{status}</Badge>;
    }
  };

  const { isPending, error, data } = useQuery({
    queryKey: ["index-users", filter],
    queryFn: () => {
      const authorization = new Headers();
      authorization.append("Authorization", myHeaders);
      const params = new URLSearchParams(filter);

      return fetch(`${URL_API}/users?${params}`, {
        method: "GET",
        headers: {
          Authorization: myHeaders,
        },
      }).then((res) => res.json());
    },
  });

  if (isPending) return "";

  if (error) return <Error />;


  return (
    <div className="space-y-6">
       <div>
        <h1 className="text-2xl sm:text-3xl font-bold text-gray-900">
          Usuarios
        </h1>
        <p className="text-gray-600 mt-2">
          Gestiona todas los usuarios de la plataforma
        </p>
      </div>

      <div className="bg-white rounded-lg shadow-sm border">
        <div className="mb-4 border-b border-gray-200 dark:border-gray-700">
        <ul
          className="w-full flex justify-start p-0 text-sm font-medium text-center border-0"
          id="default-tab"
          data-tabs-toggle="#default-tab-content"
          role="tablist"
        >
          <li className="w-full me-2 p-0" role="presentation">
            <button
              className={
                select == 0
                  ? "w-full font-bold border border-black border-t-0 border-s-0 border-e-0 inline-block p-2 border-b-2 rounded-t-lg"
                  : "w-full border border-t-0 border-s-0 border-e-0 inline-block p-2 border-b-2 rounded-t-lg"
              }
              id="profile-tab"
              data-tabs-target="#profile"
              type="button"
              role="tab"
              aria-controls="profile"
              aria-selected="false"
              onClick={() => {
                setFilter({
                  status: "activo",
                });
                setSelect(0);
              }}
            >
              Activos
            </button>
          </li>
          <li className="w-full me-2 p-0" role="presentation">
            <button
              className={
                select == 1
                  ? "w-full font-bold border border-black border-t-0 border-s-0 border-e-0 inline-block p-2 border-b-2 rounded-t-lg"
                  : "w-full border border-t-0 border-s-0 border-e-0 inline-block p-2 border-b-2 rounded-t-lg"
              }
              id="profile-tab"
              data-tabs-target="#profile"
              type="button"
              role="tab"
              aria-controls="profile"
              aria-selected="false"
              onClick={() => {
                setFilter({
                  status: "inactivo",
                });
                setSelect(1);
              }}
            >
              Inactivos
            </button>
          </li>
        </ul>
      </div>

      {/* Table */}
      <div className="rounded-md border overflow-hidden">
        <div className="overflow-x-auto">
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead className="w-[300px]">Nombre</TableHead>
                <TableHead>Ubicación</TableHead>
                <TableHead>Email</TableHead>
                <TableHead>Telefono</TableHead>
                <TableHead>Rol</TableHead>
                <TableHead>Alojamientos</TableHead>
                <TableHead>Excursiones</TableHead>
                <TableHead>Creado</TableHead>
                <TableHead>Estado</TableHead>
                <TableHead className="text-right">Acciones</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {data?.data.map((user: any) => (
                <TableRow key={user.id}>
                  <TableCell>
                    <div className="flex items-center gap-3">
                      <div className="relative w-16 h-12 rounded-md overflow-hidden flex-shrink-0">
                        <img
                          src={
                            user.image > 0
                              ? user.image
                              : "./src/assets/img/logo-en-blanco.png"
                          }
                          alt={user.firstname}
                          className="object-cover"
                        />
                      </div>
                      <div className="min-w-0">
                        <div className="font-medium text-gray-900 truncate">
                          {user.firstname}
                        </div>
                        <div className="text-sm text-gray-500">
                          ID: {user.id}
                        </div>
                      </div>
                    </div>
                  </TableCell>
                  <TableCell>
                    <div className="flex items-center gap-1 text-sm text-gray-600">
                      <MapPin className="w-3 h-3" />
                      {user.address}
                    </div>
                  </TableCell>
                  <TableCell>
                    <div className="font-medium">{user.email}</div>
                  </TableCell>
                  <TableCell>
                    <div className="font-medium">{user.phone}</div>
                  </TableCell>
                  <TableCell>
                    <Badge variant="outline">{user.role}</Badge>
                  </TableCell>
                  <TableCell>
                    <div className="font-medium">{user.propertiesCount}</div>
                  </TableCell>
                  <TableCell>
                    <div className="font-medium">{user.excursionsCount}</div>
                  </TableCell>
                  <TableCell>
                    <div className="text-sm">
                      <div className="font-medium">{""}</div>
                      <div className="text-gray-500">{user.created_at}</div>
                    </div>
                  </TableCell>
                  <TableCell>{getStatusBadge(user.status)}</TableCell>
                  <TableCell className="text-right">
                    <DropdownMenu>
                      <DropdownMenuTrigger asChild>
                        <Button variant="ghost" className="h-8 w-8 p-0">
                          <span className="sr-only">Abrir menú</span>
                          <MoreHorizontal className="h-4 w-4" />
                        </Button>
                      </DropdownMenuTrigger>
                      <DropdownMenuContent align="end">
                        <DropdownMenuLabel>Acciones</DropdownMenuLabel>
                        <DropdownMenuItem>
                          <label className="cursor-pointer text-npwrap flex">
                            <Edit className="mr-2 h-4 w-4" />
                            Editar
                            <button
                              className="hidden"
                              name="editar"
                              onClick={(e) => onClick(e, user)}
                            ></button>
                          </label>
                        </DropdownMenuItem>
                        <DropdownMenuSeparator />
                        <DropdownMenuItem className="text-red-600">
                          <label className="cursor-pointer text-npwrap flex">
                            <Power className="mr-2 h-4 w-4" />
                            Activar
                            <button
                              className="hidden"
                              name="status"
                              onClick={() => onClick("activo", {id: user.id, status: 'activo'})}
                            ></button>
                          </label>
                        </DropdownMenuItem>
                        <DropdownMenuItem className="text-red-600">
                          <label className="cursor-pointer text-npwrap flex">
                            <Trash2 className="mr-2 h-4 w-4" />
                            Suspender
                            <button
                              className="hidden"
                              name="status"
                              onClick={() => onClick("inactivo", {id: user.id, status: 'inactivo'})}
                            ></button>
                          </label>
                        </DropdownMenuItem>
                      </DropdownMenuContent>
                    </DropdownMenu>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>
      </div>

      <div id="default-tab-content">
        {isPending ? "" : error ? "" : ""}
        {isPending ? (
          ""
        ) : error ? (
          ""
        ) : (
          <Pagination data={data} setPage={setFilter} page={filter} />
        )}
      </div>
      </div>

      <Modal
        className={`animate-fadeIn`}
        dismissible
        show={modalUser}
        onClose={() => setModalUser(false)}
      >
        <div className={` ${modalUser ? "translate-y-0" : "-translate-y-4"}`}>
          <Modal.Header className="text-center w-full h-[0px]"></Modal.Header>

          <Modal.Body className="mb-3 min-h-full">
            <div className="font-bold text-md text-center py-2 text-primary">
              Perfil
            </div>

            <div className="lg:p-[50px]">
              <div className="flex mb-3">
                <div className="w-[100px] h-[100px] overflow-hidden rounded-full shadow p-1 mx-1 flex justify-center items-center">
                  <img src={user?.image} alt="" className=" object-cover " />
                </div>
                <div>
                  <span className="block text-sm">Nombre y apellido</span>
                  <span className="block mb-3">
                    {user?.firstname + " " + user?.lastname}
                  </span>
                  <span className="block text-sm">Nombre y apellido</span>
                  <span className="block mb-3">{user?.email}</span>
                  <span className="block text-sm">Telefono</span>
                  <span className="block mb-3">{user?.phone}</span>
                </div>
              </div>
              <span className="block text-sm mb-3">Rol: {user?.role}</span>
              <span className="block text-sm mb-3">
                Zona horario: {user?.timezone}
              </span>
              <span className="block text-sm mb-3">Lenguaje: {user?.lang}</span>
              <span className="block text-sm mb-3">
                Moneda: {user?.currency}
              </span>
              <span className="block text-sm mb-3">
                Propiedades publicadas: {user?.propertiesCount}
              </span>
              <span className="block text-sm mb-3">
                Excursiones publicadas: {user?.excursionsCount}
              </span>
            </div>
          </Modal.Body>

          <Modal.Footer>
            <div className="grid grid-cols-3 md:grid-cols-1 gap-3 w-full px-[40px] mb-3 "></div>
          </Modal.Footer>
        </div>
      </Modal>
    </div>
  );
};

export default Usuarios;
